export default __webpack_public_path__ + "static/media/yogamama.8be32557.jpg";